import { Outlet } from "react-router-dom";
import { Nav } from "@/components/admin/Nav";

const Layout = () => {
  return (
    <>
      <Nav />
      <div className="px-10 py-10">
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
